import http from "@/helpers/http";

export default {
    async getChats(idPlace) {
        const response = await http.get(`/places/${idPlace}/whatsapp/chats`);
        return response.data;
    },

    async getMessages(chatId, idPlace) {
        const response = await http.get(`/places/${idPlace}/whatsapp/chats/${chatId}/messages`);
        return response.data;
    },

    async sendMessage(chatId, idPlace, content, type = 'text', mediaId = null, mediaUrl = null, filename = null, isVoice = false, replyToMessageId = null) {
        const response = await http.post(`/places/${idPlace}/whatsapp/chats/${chatId}/messages`, {
            content,
            type,
            media_id: mediaId,
            media_url: mediaUrl,
            filename: filename,
            is_voice: isVoice,
            reply_to_message_id: replyToMessageId,
        });
        return response.data;
    },

    async assignChat(chatId, idPlace, assignedTo) {
        const response = await http.patch(`/places/${idPlace}/whatsapp/chats/${chatId}/assign`, {
            assigned_to: assignedTo,
        });
        return response.data;
    },

    async uploadMedia(chatId, idPlace, file) {
        const formData = new FormData();
        formData.append('file', file);

        const response = await http.post(`/places/${idPlace}/whatsapp/chats/${chatId}/media`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
        return response.data;
    },

    async getTemplates(idPlace) {
        const response = await http.get(`/places/${idPlace}/whatsapp/templates`);
        return response.data;
    },

    async createTemplate(idPlace, data) {
        const response = await http.post(`/places/${idPlace}/whatsapp/templates`, data);
        return response.data;
    },

    async updateTemplate(idPlace, templateId, data) {
        const response = await http.put(`/places/${idPlace}/whatsapp/templates/${templateId}`, data);
        return response.data;
    },

    async deleteTemplate(idPlace, templateId) {
        const response = await http.delete(`/places/${idPlace}/whatsapp/templates/${templateId}`);
        return response.data;
    },

    async createChat(idPlace, phoneNumber) {
        const response = await http.post(`/places/${idPlace}/whatsapp/chats`, {
            phone_number: phoneNumber,
        });
        return response;
    },

    async sendInitialMessage(idPlace, chatId, templateId, templateParameters = []) {
        const response = await http.post(`/places/${idPlace}/whatsapp/chats/${chatId}/initial-message`, {
            template_id: templateId,
            template_parameters: templateParameters,
        });
        return response;
    },

    async finalizeChat(idPlace, chatId) {
        const response = await http.post(`/places/${idPlace}/whatsapp/chats/${chatId}/finalize`);
        return response.data;
    },

    async deleteChat(idPlace, chatId) {
        const response = await http.delete(`/places/${idPlace}/whatsapp/chats/${chatId}`);
        return response.data;
    },
};

